import { Footer } from '@/previewThemes/serra/Footer';
import { Header } from '@/previewThemes/serra/Header';
import { SERRA_PRESETS } from '@/previewThemes/serra/presets';
import { Product } from '@/previewThemes/serra/Product';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  // See `presets.ts`: this theme's own shelf of the add-section library. The
  // house it dresses takes appointments rather than orders, and the calendar
  // that does that is one section arranged a particular way - offered here,
  // empty, rather than defaulted onto every shop that wears the serif.
  presets: SERRA_PRESETS,
  listing: {
    // Three across, not four: this theme spends 240px of the page on its
    // filter sidebar, and a fourth column on top of that shrinks the picture
    // well under the size the same product wears in a home page's featured
    // grid. Three columns beside the sidebar land on that size, which is also
    // what the search page - the other sidebar listing - already shows.
    grid: 'grid-cols-2 gap-6 lg:grid-cols-3',
    filters: 'sidebar',
    columns: 3,
    card: 'airy',
  },
  // Hairline rules, never fills: this house separates with a 1px line. Kept
  // even though the sample shop has no basket - a theme is a look, and a
  // boutique that takes this one to a shop with a till gets the till dressed.
  cart: { grid: 'mt-10 grid gap-12 lg:grid-cols-3', panel: 'outlined' },
  checkout: {
    grid: 'mt-10 grid items-start gap-12 lg:grid-cols-[minmax(0,1fr)_23rem]',
    panel: 'outlined',
  },
  search: {
    grid: 'mt-10 grid gap-12 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-6 lg:grid-cols-3',
    columns: 3,
    card: 'airy',
    panel: 'outlined',
  },
  blog: { list: 'grid gap-10 sm:grid-cols-2 lg:grid-cols-3', title: 'text-2xl' },
  category: { grid: 'grid gap-6 sm:grid-cols-2 lg:grid-cols-3', tile: 'bare' },
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-4xl' },
        wideButtons: true,
        gallery: { aspect: 'portrait', thumbs: 'rail' },
      },
    },
  },
};
